import { triggerFileDownload } from "@gtmhub/shared/dom";
import { IDeltaHistorySync, IDeltaHistorySyncOperation, IDeltaHistorySyncRecord } from "./models";
import dayjs from "@gtmhub/dayjs";
import { toCsv } from "@gtmhub/shared/utils";

export class WorkdayOperationsReportService {
  public triggerDownload(sync: IDeltaHistorySync): void {
    const records: IDeltaHistorySyncRecord[] = sync.operations.map((operation) => {
      return {
        ...operation,
        nameOrEmail: this.getNameOrEmail(operation),
      };
    });
    const operationsReport = toCsv(records, [
      "workdayEntityId",
      "gtmhubEntityId",
      "entityType",
      "operationType",
      "endTime",
      "success",
      "skipped",
      "error",
      "info",
      "nameOrEmail",
    ]);

    triggerFileDownload(new Blob([operationsReport], { type: "application/octet-stream" }), `operations-report_${dayjs(sync.endTime).format("YYYY-MM-DD_HH-mm")}.csv`);
  }

  private getNameOrEmail(operation: IDeltaHistorySyncOperation): string | undefined {
    if (operation.entityDetails == null) {
      return;
    }
    if ("name" in operation.entityDetails) {
      return operation.entityDetails.name;
    } else {
      return operation.entityDetails.email;
    }
  }
}
